import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'accept-guardian-role');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'guardian_proxy_invitations',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/accept-guardian-role.js